<script>
 import 'whatwg-fetch';
 import 'promise-polyfill/src/polyfill';
 import { onMount } from 'svelte';
 import Map from './Map.svelte';
 export let ready;
 export let params;

 let company;
 let center = null;
 let facilities = [];

 onMount( function() { getCompanyDetails() } );

 function getCompanyDetails() {

   fetch('/api/product-locator/company/' + params.company)
     .then(async function(response) {
       var data = await response.json();

       center = { lat: parseFloat(data.center[0]),
                  lng: parseFloat(data.center[1])
                };

       company = data.company;
       facilities = data.company.facilities;
     });
 }
</script>

{#if company}
  <div class="left">
  <div class="company">
    <h2>{ company.name }</h2>

    {#if company.logo}
      <p class="logo-container"><img alt="{company.name} logo" class="company-logo" src="/data{company.logo}"></p>
    {/if}

    {#if company.contact}
      <p><strong>Primary Contact Person:</strong> {company.contact}</p>
    {/if}

    {#if company.phone}
      <p><strong>Primary Contact Phone:</strong> {company.phone}</p>
    {/if}

    {#if company.city}
      <p><strong>City:</strong> {company.city}, {company.state}</p>
    {/if}

    {#if company.website}
      <p><strong>Website:</strong> <a href="{company.website}">{company.website}</a></p>
    {/if}

    {#if company.description}
      <p style="padding-top: 15px">{ company.description}</p>
    {/if}

    {#if facilities}
      <h2>Facilities</h2>
      <ul>
        {#each facilities as facility}
          <li><a href="/buyers-guide/{facility.code}">{facility.full_name}</a></li>
        {/each}
      </ul>
    {/if}
  </div>
  </div>
  <div class="right map-outer-wrap">
    {#if ready}
      <Map companies={[company]} center={center} ></Map>
    {/if}
  </div>
{/if}

<style>
 .company ul {
   padding-left: 20px;
 }

 .company ul li {
   line-height: 1.4rem;
 }

 .company p {
   padding: 0;
 }

 .logo-container {
   display: block;
   position: relative;
   overflow: hidden;
   width: 200px;
 }

 @media (max-width: 850px) {
   .left, .right {
     width: 100%;
   }
 }

 .left {
   width: 50%;
 }

 .right {
   width: 50%;
 }
</style>
